import { DateTime } from 'luxon';

import { Diff } from '../../types';
import { StoreDayHours } from '../StoreDayHours';

export const getStoreDiffFromMoment = (
	hours: StoreDayHours,
	time: DateTime
): Diff => {
	return {
		open: time.diff(hours.open, 'minutes').minutes,
		close: time.diff(hours.close, 'minutes').minutes
	};
};
